import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import {
  Box, CircularProgress, Container, IconButton, Stack,
} from '@mui/material';
import { CloseRounded } from '@mui/icons-material';
import Images from '../../../Configs/images';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

export default function ConfirmationModal({
  open,
  handleClose,
  handleAgree,
  classes,
  title,
  desc,
  cancelText,
  confirmText,
  maxWidth,
  minWidth,
  noCancel,
  direction,
  btnTextSize,
}) {
  const [isLoading, setLoading] = useState(false);

  const handleProcessAgree = async () => {
    setLoading(true);
    try {
      await handleAgree();
    } catch (err) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleProcessClose = () => {
    setLoading(false);
    handleClose();
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleProcessClose}
      maxWidth={maxWidth || 'sm'}
      PaperProps={{
        sx: {
          position: 'fixed',
          bottom: 60,
          borderRadius: '10px',
        },
      }}
    >
      <div className={classes.root} style={{ minWidth: minWidth || 300 }}>
        <Container>
          <Box display="flex" justifyContent="space-between">
            <Box
              bgcolor="#FDE0E0"
              borderRadius={6}
              alignItems="center"
              justifyContent="center"
              width={40}
              height={40}
              display="inline-flex"
            >
              <img src={Images.InfoRed} alt="are u sure?" />
            </Box>

            {!noCancel
            && (
            <Box>
              <IconButton sx={{ p: 0 }} onClick={handleClose}>
                <CloseRounded />
              </IconButton>
            </Box>
            )}
          </Box>
          {!!title
          && (
          <Box className="s-16 weight-700" mt={2}>
            {title}
          </Box>
          )}
          <div className="mt-1 s-14 height-14">
            {desc}
          </div>
          <Stack mt={2} gap={1} direction={direction || 'column'}>
            <Button
              disabled={isLoading}
              startIcon={isLoading && (<CircularProgress size={16} sx={{ mr: 1, color: '#fff' }} />)}
              fullWidth
              size="medium"
              variant="contained"
              className="btn-contained"
              onClick={handleProcessAgree}
              sx={{ whiteSpace: 'nowrap', px: 0.5, fontSize: `${btnTextSize || '16px'} !important` }}
            >
              {confirmText || 'Confirm'}
            </Button>
            {!noCancel
            && (
            <Button
              fullWidth
              size="medium"
              variant="outlined"
              className="btn-outlined"
              onClick={handleClose}
              sx={{ whiteSpace: 'nowrap', px: 0.5, fontSize: `${btnTextSize || '16px'} !important` }}
            >
              {cancelText || 'Cancel'}
            </Button>
            )}
          </Stack>
        </Container>
      </div>
    </Dialog>
  );
}
